
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TicketsModule } from '@/store/modules/tickets'
import rateContent from './rateContent.vue'
import { AppModule, DeviceType } from '@/store/modules/app'

@Component({
  name: 'RateDialog',
  components: {
    rateContent
  }
})
export default class extends Vue {
  get dialogVisible() {
    return TicketsModule.rateDialog
  }

  get device() {
    return AppModule.device
  }

  get isMobile() {
    return this.device === DeviceType.Mobile
  }

  @Watch('dialogVisible')
  private onDialogStatusChange(value: boolean) {
    if (value) { // 打开弹框
    }
  }

  // 事件节点组件更新数据，也在父组件中详情更新后调用
  private handleEvents() {
    this.$refs.rateContent && (this.$refs.rateContent as any).handleEvents()
  }

  private handleSuccess(res: any) {
    if (res.stat) {
      this.$emit('handleSuccess', res)
    }
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'rateDialog',
      value: false
    })
  }
}
